var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-down-circle",
    d: "M62,48A14,14,0,1,1,48,62,14,14,0,0,1,62,48ZM55.851,62.313a1.077,1.077,0,0,0,1.523.006L60.923,58.8v8.991a1.077,1.077,0,1,0,2.154,0V58.8l3.549,3.522a1.078,1.078,0,0,0,1.517-1.531l-5.385-5.344a1.077,1.077,0,0,0-1.517,0l-5.385,5.344a1.077,1.077,0,0,0-.006,1.525Z",
    transform: "translate(76 76) rotate(180)",
    fill: "#9c9b9a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCircle);
export default __webpack_public_path__ + "static/media/down-circle.1ff27e6b1ef591d4541cc506d174b956.svg";
export { ForwardRef as ReactComponent };